// extracted by mini-css-extract-plugin
export var equalColumn = "_er-0";